<template>
  <div>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-text>
          {{ textePopup }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> Fermer </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12">
        <v-img
          src="@/assets/FIRSILOGO.png"
          contain
          max-height="50"
          max-width="150"
          class="mr-2"
        ></v-img>
      </v-col>
    </v-row>
    <Annexes v-show="UtilisateurConnecte" />
    <NonAutorise v-show="!UtilisateurConnecte" />
  </div>
</template>
<script>
import Annexes from "@/components/CandidatureBourse/ListeAnnexes";
import NonAutorise from "@/components/PageNonAutoriseExtranet";

export default {
  name: "AnnexesCandidature",
  components: {
    Annexes,
    NonAutorise,
  },
  data() {
    return {
      textePopup: null,
      dialog: false,
      UtilisateurConnecte: false,
      $storeDemandeBourse: this.$storeDemandeBourse,
      $storeCommun : this.$storeCommun,
      loader: true,
    };
  },
  created() {
    document.title = "Annexes candidature";
  },
  mounted() {
    var self = this;
    if (this.$route.query.t) {
      this.$storeDemandeBourse.DonneesFormulaire.TokenExtranet =
        this.$route.query.t.replace(/\s/g, "+");
      Promise.all([
        this.$storeDemandeBourse
          .GetListeAnnexesFirsi(
            this.$storeDemandeBourse.DonneesFormulaire.TokenExtranet
          )
          .then((response) => {
            if (response) {
              this.$storeDemandeBourse.MapperDtoEnDonneesFormulaire(
                response.data, this.$storeCommun
              );
            }
          }),
      ]).then(function () {
        self.loader = false;
        if (self.$storeDemandeBourse.DonneesFormulaire.EncryptId) {
          self.UtilisateurConnecte = true;
        }
      });
    } else {
      this.UtilisateurConnecte = false;
      this.loader = false;
    }
  },
  methods: {},
};
</script>